import { ComponentType } from 'react';
import { ButtonProps } from '@material-ui/core';
import { AppPermissions, VenueType, useGetInitInfoQuery } from '../../generated/graphql';
import { useUser } from '../hooks/auth';
import { checkAccess, checkVenueTypeAccess } from '../helpers';

export type ProtectedActionProps = ButtonProps & {
    permissions?: Partial<Pick<AppPermissions, 'backoffice' | 'warehouse'>>;
    allowedVenueTypes?: Array<VenueType>;
    component?: ComponentType<ButtonProps>;
    children: JSX.Element;
};

const ProtectedComponent = ({ permissions, children, allowedVenueTypes }: ProtectedActionProps) => {
    const { data } = useGetInitInfoQuery({ fetchPolicy: 'cache-only' });
    const { user: { venueType } } = useUser();

    const hasAccess = data
        ? checkVenueTypeAccess(allowedVenueTypes, venueType) && checkAccess(permissions, data.employeePermissions)
        : false;

    if (!hasAccess) {
        return null;
    }

    return children;
};

export default ProtectedComponent;
